import { useState } from "react";
import {
  DivContainerTable,
  DivContentTable,
  HeaderSubTableAppoinment,
  StyledTable,
} from "../AdminReportStyle";
import { SearchGetRegister } from "../SearchGetRegister";
import { Appointment } from "../interfaces/Volantes.interfaces";

import ICButton from "../../../images/ic_vector_button_report.svg";
import ICButtonDisabled from "../../../images/ic_vector_button_report_disabled.svg";
import ICButtonTop from "../../../images/ic_vector_top_report.svg";
import { StatusType } from "../AdminReportResource";
import { NULL, PROCESSING, SUCCESS } from "../../../utils/valueStaticConstants";
interface Props {
  statusEndpoint: StatusType;
  loadReportExecutor: any;
}
export const ReportAppointmentTurn = (props: Props) => {
  const { loadReportExecutor, statusEndpoint } = props;

  const showBackground =
    (loadReportExecutor.status === SUCCESS &&
      statusEndpoint === SUCCESS &&
      loadReportExecutor.data.count === 0) ||
    loadReportExecutor.status === PROCESSING
      ? true
      : statusEndpoint === NULL
      ? true
      : false;

  const [showTable, setShowTable] = useState(false);
  const [indexActive, setIndexActive] = useState<number>();

  return (
    <div>
      <DivContainerTable>
        <DivContentTable>
          <StyledTable id="resizeMe">
            <thead>
              <tr>
                <th style={{ resize: "horizontal" }}>
                  {"Vehículos asociados"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"RUC de la agencia aduanera"}
                </th>
                <th style={{ resize: "horizontal" }}>{"Agencia aduanera"}</th>
                <th style={{ resize: "horizontal" }}>{"Número de Volante"}</th>
                <th style={{ resize: "horizontal" }}>
                  {"Número de pedido en SAP"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"Número de factura SD"}
                </th>
                <th style={{ resize: "horizontal" }}>{"Número de cita"}</th>
                <th style={{ resize: "horizontal" }}>{"Estado de cita"}</th>
                <th style={{ resize: "horizontal" }}>
                  {"Creación de la cita"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"Última actualización de la cita"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"Fecha de retiro de la carga"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"Hora inicio de la cita"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"Hora final de la cita"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"Nombre del despachador aduanero"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"Documento de identidad del despachador aduanero"}
                </th>
                <th style={{ resize: "horizontal" }}>{"Estado de turno"}</th>
                <th style={{ resize: "horizontal" }}>
                  {"Número de turno HERMES"}
                </th>
                <th style={{ resize: "horizontal" }}>{"Número de VCT"}</th>
                <th style={{ resize: "horizontal" }}>{"Número dique"}</th>
              </tr>
            </thead>

            {loadReportExecutor.status === SUCCESS &&
              statusEndpoint === SUCCESS && (
                <tbody>
                  {loadReportExecutor.data.data_report.map(
                    (elem: Appointment, idx: number) => {
                      return (
                        <>
                          <tr
                            key={idx}
                            className={
                              showTable && indexActive === idx
                                ? "background-in-hover-active"
                                : "background-in-hover"
                            }
                          >
                            <td style={{ textAlign: "start" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <button
                                  className="p-row-toggler p-link"
                                  type="button"
                                  style={{
                                    marginRight: "1rem",
                                    display: "flex",
                                  }}
                                >
                                  {showTable && indexActive === idx ? (
                                    <img
                                      src={ICButtonTop}
                                      alt=""
                                      onClick={() => {
                                        setIndexActive(idx);
                                        setShowTable(false);
                                      }}
                                    />
                                  ) : elem.vehicle_data.length === 0 ? (
                                    <img
                                      src={ICButtonDisabled}
                                      alt=""
                                      style={{ cursor: "not-allowed" }}
                                    />
                                  ) : (
                                    <img
                                      src={ICButton}
                                      alt=""
                                      onClick={() => {
                                        setIndexActive(idx);
                                        setShowTable(true);
                                      }}
                                    />
                                  )}
                                </button>

                                <div>
                                  {elem.vehicle_data.length > 1
                                    ? elem.vehicle_data.length + " Vehículos"
                                    : elem.vehicle_data.length === 0
                                    ? "Sin Vehículo"
                                    : elem.vehicle_data.length + " Vehículo"}
                                </div>
                              </div>
                            </td>
                            <td>{elem.agent_ruc}</td>
                            <td>{elem.agent_name}</td>
                            <td>{elem.volante_num}</td>
                            <td>{elem.factura_num}</td>
                            <td>{elem.tci_num}</td>
                            <td>{elem.numeric_id}</td>
                            <td>
                              {elem?.appointment_status?.label
                                ? elem?.appointment_status?.label
                                : "-"}
                            </td>
                            <td>{elem.created_at}</td>
                            <td>{elem.updated_at}</td>
                            <td>{elem.withdrawal_date}</td>
                            <td>{elem.timeslot_start}</td>
                            <td>{elem.timeslot_end}</td>
                            <td>{elem.custom_dispatcher_full_name}</td>
                            <td>{elem.custom_dispatcher_document_number}</td>
                            <td>
                              {elem?.turn_status?.label
                                ? elem?.turn_status?.label
                                : "-"}
                            </td>
                            <td>{elem.turn_num}</td>
                            <td>{elem.vct_id}</td>
                            <td>{elem.dock_num}</td>
                          </tr>

                          <>
                            {showTable && indexActive === idx && (
                              <StyledTable id="resizeMe">
                                <thead>
                                  <tr>
                                    <HeaderSubTableAppoinment>
                                      Tipo de auto
                                    </HeaderSubTableAppoinment>
                                    <HeaderSubTableAppoinment>
                                      <div>Placa de auto</div>
                                    </HeaderSubTableAppoinment>
                                    <HeaderSubTableAppoinment>
                                      ID chofer
                                    </HeaderSubTableAppoinment>
                                    <HeaderSubTableAppoinment>
                                      Nombre chofer
                                    </HeaderSubTableAppoinment>
                                  </tr>
                                </thead>
                                <tbody>
                                  {elem.vehicle_data.map((vehicle) => {
                                    return (
                                      <tr className="background-in-hover">
                                        <td>{vehicle.category}</td>
                                        <td>{vehicle.plate}</td>
                                        <td>
                                          {vehicle.driver_document_number}
                                        </td>
                                        <td>{vehicle.driver_full_name}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </StyledTable>
                            )}
                          </>
                        </>
                      );
                    }
                  )}
                </tbody>
              )}
          </StyledTable>
        </DivContentTable>
      </DivContainerTable>

      {showBackground && <SearchGetRegister />}
    </div>
  );
};
